import { createAction, props } from "@ngrx/store";
import { UploadFileContactInformation } from "src/app/pages/contact-information/model/potential-customer";


export const loadPremisesPhotos = createAction('[PremisesPhotos] upload files contact information', props<{ uploadFileContactInformationInfo: UploadFileContactInformation }>());
export const resetPremisesPhotos = createAction('[PremisesPhotos] resetFiles status inital on contact information');
